import currency from 'currency.js';

export const formatPrice = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL'
});

export const toDecimals = (value, precision = 2) => Number(currency(value, { precision }));

// export const formatCellphoneNumber = (cellphone: number | string) => {
//   return cellphone.toString().replace(/^(\+55\s?)?(\(?\d{2}\)?\s?)?(\d{4,5}\-\d{4})$/, '($1) $2');
// };

export const formatCellphoneNumber = (cellphone: string) => {
  // Remove todos os caracteres que não sejam dígitos
  const digitos = cellphone?.replace(/\D/g, '');

  // Aplica a formatação, verificando se é celular ou telefone fixo
  if (digitos?.length === 11) {
    return digitos?.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else {
    return digitos?.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
  }
};

export const realToNumber = (value: string | number) => {
  const str =
    typeof value === 'number'
      ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : value;

  if (str === undefined || str === null) return value;

  const fixedStr = str.replace(/(\d)\.$/, '$1');
  const numberStr = fixedStr.replace(/[^\d,.]+/g, '').replace(',', '.');
  return Number.parseFloat(numberStr);
};

export const formatCpfCnpj = (value: string) => {
  const governamentalCode = value.replace(/\D/g, '');

  if (governamentalCode?.length === 11) {
    return governamentalCode?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (governamentalCode?.length === 14) {
    return governamentalCode?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    return governamentalCode;
  }
};

export const formatDateMask = (value: string) => {
  const digits = value?.replace(/\D/g, '').slice(0, 8) ?? '';

  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return digits.replace(/(\d{2})(\d+)/, '$1/$2');
  return digits.replace(/(\d{2})(\d{2})(\d+)/, '$1/$2/$3');
};

export const formatCpfCnpjForFilter = (value: string) => {
  const governamentalCode = value.replace(/\D/g, '');

  if (governamentalCode?.length === 11) {
    return governamentalCode?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (governamentalCode?.length === 14) {
    return governamentalCode?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  return value;
};

export const millisecondsToHours = (milliseconds: number) => {
  const segundos = Math.floor(milliseconds / 1000);
  const minutos = Math.floor(segundos / 60);
  const horas = Math.floor(minutos / 60);

  const minutosRestantes = minutos % 60;
  const segundosRestantes = segundos % 60;

  return {
    hours: horas.toString().padStart(2, '0'),
    minutes: minutosRestantes.toString().padStart(2, '0'),
    seconds: segundosRestantes.toString().padStart(2, '0')
  };
};

export const formatReal = (value: number) => value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
